<template>
  <div>
    <section id="topbar" class="d-flow-root">
      <div
        :class="
          !($route.name == 'memberProfile' || $route.name == 'memberProfilej')
            ? 'container clearfix'
            : 'px-4'
        "
      >
        <div
          class="contact-info float-left d-none d-lg-block"
          v-if="$root.config"
        >
          <slot
            v-if="
              !(
                $route.name == 'memberProfile' ||
                $route.name == 'memberProfilej'
              )
            "
          >
            <i class="fa fa-envelope-o"></i>
            <a v-if="$root.config" :href="'mailto:' + $root.config.email">{{
              $root.config.email
            }}</a>
            <i class="fa fa-phone"></i> {{ $root.config.mobile }}
          </slot>
          <slot v-else>
            <slot v-if="is_japan && $root.jpLogged">
              <router-link :to="{ name: 'japan.japanDashboard' }"
                ><i class="fa fa-home"></i> Home</router-link
              >
              <router-link :to="{ name: 'japan.japanProfile' }" class="pl-3"
                ><i class="fa fa-graduation-cap"></i> B2B List</router-link
              >
            </slot>
            <slot v-else>
              <router-link :to="{ name: 'home.page' }"
                ><i class="fa fa-home"></i> Home</router-link
              >
              <router-link :to="{ name: 'enlisted-company' }" class="pl-3"
                ><i class="fa fa-graduation-cap"></i> Enlisted
                Company</router-link
              >
            </slot>
          </slot>
        </div>
        <div class="social-links float-right">
          <a
            v-if="$root.config"
            :href="$root.config.twitter"
            target="_blank"
            class="twitter"
            ><i class="fa fa-twitter"></i
          ></a>
          <a
            v-if="$root.config"
            :href="$root.config.facebook"
            target="_blank"
            class="facebook"
            ><i class="fa fa-facebook"></i
          ></a>
          <a
            v-if="$root.config"
            :href="$root.config.youtube"
            target="_blank"
            class="google-plus"
            ><i class="fa fa-youtube"></i
          ></a>
          <a
            v-if="$root.config"
            :href="$root.config.linkedin"
            target="_blank"
            class="linkedin"
            ><i class="fa fa-linkedin"></i
          ></a>

          <slot v-if="$root.lang == 'en'">
            <span
              @click="changeLanguage('jp')"
              class="border rounded p-1 border-danger bg-custom focus language"
            >
              <img :src="$root.asset + 'img/japan.png'" alt="" /> JP
            </span>
          </slot>
          <slot v-else>
            <span
              @click="changeLanguage('en')"
              class="border rounded p-1 border-danger bg-custom focus language"
            >
              <img :src="$root.asset + 'img/english.png'" alt="" /> EN
            </span>
          </slot>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_japan: false,
    };
  },
  methods: {
    changeLanguage(language) {
      axios
        .get("/locale", { params: { language: language } })
        .then((response) => {
          location.reload();
        });
    },
  },
  mounted() {
    if (Object.keys(this.$route.params).length == 2) {
      this.is_japan = true;
    }
  },
};
</script>
